import React, { useState, useRef} from "react";
import ReCAPTCHA from "react-google-recaptcha";

function Contact() {
  const [formData, setFormData] = useState({
    nombre: '',
    correo: '',
    telefono: '',
    mensaje: ''
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const [captchaValido, setCaptchaValido] = useState(false); // Estado para habilitar/deshabilitar botón
  const captchaRef = useRef(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleCaptchaChange = (value) => {
    // Si 'value' tiene algo, Google nos confirmó que es un humano
    if (value) {
      setCaptchaValido(true);
    } else {
      setCaptchaValido(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaValido) {
      setStatus({ type: 'error', message: 'Por favor, completa el captcha.' });
      return;
    }
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${BASE_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({
          type: 'success',
          message: '¡Mensaje enviado con éxito! Te responderé pronto.'
        });
        // Limpiar el formulario
        setFormData({
          nombre: '',
          correo: '',
          telefono: '',
          mensaje: ''
        });
        setCaptchaValido(false); // Resetear estado
        captchaRef.current.reset();
      } else {
        setStatus({
          type: 'error',
          message: data.message || 'Error al enviar el mensaje. Intenta nuevamente.'
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus({
        type: 'error',
        message: 'Error de conexión. Por favor intenta más tarde.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container contactform my-5">
      <section id="contacto"></section>
      <div className="contacto rounded shadow p-4">
        <div className="text-center mb-4 p-1">
          <h3 className="fw-bold">Conectá conmigo</h3>
          <h5 className="text-muted">
            Disponible para consultoría, análisis de mercados y charlas sobre economía argentina
          </h5>
        </div>
        <div className="row">
          {/* Columna izquierda: Imagen + Redes */}
          <div className="col-12 col-md-6 d-flex flex-column justify-content-between">
              <div className="position-relative h-100">
          {/* Foto de fondo */}
          <div 
            className="rounded overflow-hidden h-100"
            style={{
              backgroundImage: 'url("/Seba redes.jpeg")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative'
            }}
  >
    {/* Overlay oscuro para mejor contraste */}
    <div 
    className="position-absolute w-100 h-100"
    style={{
      background: 'inherit',
      filter: 'grayscale(100%)',
      top: 0,
      left: 0,
      zIndex: 1
    }}
  ></div>

    {/* Contenido superpuesto */}
    
<div className="position-relative h-100 d-flex flex-column justify-content-end p-4" style={{ zIndex: 2, backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
  {/* Redes Sociales */}
  <div className="mb-3 text-center">
    <p className="text-white mb-2"><small className="fw-semibold">Redes Sociales | Consultoras</small></p>
    <div className="d-flex justify-content-center gap-3">
      <a 
        href="https://x.com/smenescaldi" 
        target="_blank" 
        rel="noopener noreferrer"
        className="institution-link-overlay"
        title="Twitter"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '8px',
          borderRadius: '8px',
          transition: 'all 0.3s ease',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '45px',
          height: '45px'
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16" style={{ color: '#000' }}>
          <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
        </svg>
      </a>
      <a 
        href="https://www.linkedin.com/in/smenescaldi/" 
        target="_blank" 
        rel="noopener noreferrer"
        className="institution-link-overlay"
        title="LinkedIn"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '8px',
          borderRadius: '8px',
          transition: 'all 0.3s ease',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '45px',
          height: '45px'
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16" style={{ color: '#0a66c2' }}>
          <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
        </svg>
      </a>
      <a 
        href="https://ecogo.com.ar/" 
        target="_blank" 
        rel="noopener noreferrer"
        className="institution-link-overlay"
        title="EcoGo"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '8px',
          borderRadius: '8px',
          transition: 'all 0.3s ease',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '45px', 
          height: '45px'
        }}
      >
        <img 
          src="\ecogo_logo.png" 
          alt="Logo Eco Go" 
          style={{ 
            width: "35px", 
            height: "35px", 
            objectFit: "contain"
          }} 
        />
      </a>
      <a 
        href="https://iesonline.ar/" 
        target="_blank" 
        rel="noopener noreferrer"
        className="institution-link-overlay"
        title="IES"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '8px',
          borderRadius: '8px',
          transition: 'all 0.3s ease',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '45px', 
          height: '45px'
        }}
      >
        <img 
          src="/Logo_IES_2011.jpg" 
          alt="Logo IES" 
          style={{ 
            width: "100%", // Cambiado para que sea consistente
            height: "100%" ,
            objectFit: "contain"
          }} 
        />
      </a>
    </div>
  </div>

  

  {/* Medios */}
  <div className="text-center">
    <p className="text-white mb-2"><small className="fw-semibold">Apariciones en medios</small></p>
    <div className="d-flex justify-content-center gap-2 flex-wrap">
      <a 
        href="https://www.lanacion.com.ar/autor/Sebasti%C3%A1n_Menescaldi/" 
        target="_blank" 
        rel="noopener noreferrer"
        className="media-link-overlay"
        title="La Nación"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '6px',
          borderRadius: '50%',
          transition: 'all 0.3s ease',
          display: 'inline-flex',
          width: '45px',
          height: '45px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img 
          src="/la nacion logo.jpeg" 
          alt="La Nación" 
          style={{ 
            width: "30px", 
            height: "30px", 
            objectFit: "contain",
            borderRadius: '50%'
          }} 
        />
      </a>
      <a 
        href="https://www.clarin.com/autor/sebastian-menescaldi" 
        target="_blank" 
        rel="noopener noreferrer"
        className="media-link-overlay"
        title="Clarín"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '6px',
          borderRadius: '50%',
          transition: 'all 0.3s ease',
          display: 'inline-flex',
          width: '45px',
          height: '45px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img 
          src="\clarin logo.png" 
          alt="Clarín" 
          style={{ 
            width: "30px", 
            height: "30px", 
            objectFit: "contain",
            borderRadius: '50%'
          }} 
        />
      </a>
      <a 
        href="https://www.perfil.com/temas/sebastian-menescaldi" 
        target="_blank" 
        rel="noopener noreferrer"
        className="media-link-overlay"
        title="Perfil"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '6px',
          borderRadius: '50%',
          transition: 'all 0.3s ease',
          display: 'inline-flex',
          width: '45px',
          height: '45px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img 
          src="/perfillogo.png" 
          alt="Perfil" 
          style={{ 
            width: "30px", 
            height: "30px", 
            objectFit: "contain",
            borderRadius: '50%'
          }} 
        />
      </a>
      <a 
        href="https://eleconomista.com.ar/autor/sebastian-menescaldi-a702" 
        target="_blank" 
        rel="noopener noreferrer"
        className="media-link-overlay"
        title="El Economista"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '6px',
          borderRadius: '50%',
          transition: 'all 0.3s ease',
          display: 'inline-flex',
          width: '45px',
          height: '45px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img 
          src="\el economista logo.png" 
          alt="El Economista" 
          style={{ 
            width: "30px", 
            height: "30px", 
            objectFit: "contain",
            borderRadius: '50%'
          }} 
        />
      </a>
    </div>
    </div>
    </div>
    </div>
    </div>
          </div>

          {/* Columna derecha: Formulario */}
          <div className="col-12 col-md-6 mt-4 mt-md-0">
            {/* Mensajes de estado */}
            {status.message && (
              <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'} alert-dismissible fade show`} role="alert">
                {status.message}
                <button type="button" className="btn-close" onClick={() => setStatus({ type: '', message: '' })}></button>
              </div>
            )}

            <form className="h-100 d-flex flex-column justify-content-between" onSubmit={handleSubmit}>
              <div>
                <div className="mb-3">
                  <label htmlFor="nombre" className="form-label">Nombre Completo</label>
                  <input
                    type="text"
                    className="form-control"
                    id="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                  />
                </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="correo" className="form-label">Correo Electrónico</label>
                  <input
                    type="email"
                    className="form-control"
                    id="correo"
                    value={formData.correo}
                    onChange={handleChange}
                    required
                    aria-describedby="emailHelp"
                  />
                  <div id="emailHelp" className="form-text">
                    Nunca compartiremos tu correo
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="telefono" className="form-label">Teléfono</label>
                  <input
                    type="tel"
                    className="form-control"
                    id="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                  />
                </div>
              </div>

                <div className="mb-3">
                  <label htmlFor="mensaje" className="form-label">Mensaje</label>
                  <textarea
                    className="form-control"
                    id="mensaje"
                    rows="5"
                    maxLength="1000"
                    value={formData.mensaje}
                    onChange={handleChange}
                    required
                  ></textarea>
                  <div className="form-text">Máximo 1000 caracteres</div>
                  
                  <div className="mt-3">
                    <ReCAPTCHA
                      ref={captchaRef}
                      sitekey="6LdH2WAsAAAAAEPfkGfCFRyGhQQWMFnt-unxCXDV" 
                      onChange={handleCaptchaChange}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary w-100 mt-3"
                    disabled={loading || !captchaValido}
                  >
                    {loading ? 'Enviando...' : 'Enviar mensaje' } 
                    <i className="bi bi-send ms-2"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    
  );
}

export default Contact;